import type { ISO8601String, UUIDString } from '@aigc/types';
import type { UserDto } from '../user/models';

export interface SkillAttachmentDto {
  id: UUIDString;
  mime: string;
  filename: string;
  file_url: string;
  created_at: EpochTimeStamp;
}

export const enum SkillScope {
  Global = 1 << 0,
  Group = 1 << 1,
  Self = 1 << 2,
}

export function toSkillScopeName(scope: SkillScope) {
  switch (scope) {
    case SkillScope.Global:
      return '全局';
    case SkillScope.Group:
      return '部门';
    case SkillScope.Self:
      return '个人';
    default:
      break;
  }
}

export interface SkillOptionDto {
  id: number;
  name: string;
  description: string | null;
}

export interface SkillDto {
  id: number;
  scope: SkillScope;
  name: string;
  department_names?: string[] | null;
  description: string | null;
  instructions: string;
  attachments: SkillAttachmentDto[];
  created_at: ISO8601String;
  updated_at: ISO8601String | null;
  created_by: string;
  creator?: UserDto | null;
  updated_by: string | null;
  updater?: UserDto | null;
}

export interface SkillQueryInputDto {
  name?: string;
  page: number;
  size: number;
}

export interface SkillMutationInputDto {
  name: string;
  department_names?: string[];
  scope?: SkillScope;
  description: string | null;
  instructions: string;
  attachment_ids: UUIDString[];
}
